import Vue from 'vue'
import Router from 'vue-router'
import List from '@/template/pageList/list'
import Content from '@/template/pageContent/content'
import ChoiceTemplate from '@/choicetemplate'
// 报名
import sign from '@/template/sign/sign'
// 报名查询
import signquery from '@/template/sign/signquery'
import pics from '@/template/pageContent/pics'
import store from '../store';
import api from "@/axios";
import _ from "underscore";
Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/:gameId',
      name: 'choicetemplate',
      component: ChoiceTemplate,
      meta: {
        menuname: '首页',
      },
    },
    //图文路由
    {
      path: '/:gameId/func/:func',
      name: 'procedures',
      component: Content,
    },
    {
      path: '/:gameId/content/:uuid',
      name: 'content',
      component: Content,
    },
    //列表路由
    {
      path: '/:gameId/list/:key',
      name: 'list',
      component: List,
    },
    // 报名
    // {
    //   path: '/:gameId/sign',
    //   name: 'sign',
    //   component: sign,
    //   meta: {
    //     menuname: '立即报名',
    //   },
    // },
    {
      path: '/:gameId/pics/:key',
      name: 'pics',
      component: pics,
      meta: {
        menuname: '精彩图集',
      },
    },
    {
      path: '/:gameId/sign/signquery',
      name: 'signquery',
      component: signquery,
      meta: {
        menuname: '报名查询',
      },
    },
    {
      path: '/:gameId/score/scorequery',
      name: 'scorequery',
      component: signquery,
      meta: {
        menuname: '成绩查询',
      },
    }
  ]
})

// 验证 token，存在才跳转
router.beforeEach((to, from, next) => {
  console.log(to, from);
  if (to.fullPath === '/') {
    //无参数 校验域名
    api.checkdomain({}).then(({ data }) => {
      if (data.data.type == 'window') window.location.href = data.data.location;
      else next({ path: data.data.location });
    });
  } else {
    api.checkdomain({}).then(({ data }) => {
      console.log(data);
      if (data.code === 1) {
        window.location.href = data.data.location;
      } else {
        api.getinitdata({ gameId: to.params.gameId }).then(({ data }) => {
          if (data.code === 0) {
            store.dispatch("SetAppWeb", data.data.appweb);
            store.dispatch("SetMatch", data.data.match);
            store.dispatch("SetGameId", to.params.gameId);
            if (to.meta.menuname) {
              store.dispatch("SetMenuName", to.meta.menuname);
            } else if (to.params.uuid) {
              var menuname = "";
              for (var i = 0; i < data.data.appweb.menus.length; i++) {
                if (data.data.appweb.menus[i].id == to.params.uuid || data.data.appweb.menus[i].newsId == to.params.uuid) {
                  menuname = data.data.appweb.menus[i].name
                }
                if (!menuname) {
                  for (var j = 0; j < data.data.appweb.menus[i].subs.length; j++) {
                    if (data.data.appweb.menus[i].subs[j].id == to.params.uuid || data.data.appweb.menus[i].subs[j].newsId == to.params.uuid) {
                      menuname = data.data.appweb.menus[i].subs[j].name;
                      break;
                    }
                  }
                }
                if (menuname) {
                  store.dispatch("SetMenuName", menuname);
                  break;
                }
              }
            } else if (to.params.key || to.params.func) {
              store.dispatch("SetMenuName", to.params.key || to.params.func);
            }
          }
          next();
        });
      }
    });

  }
});

export default router


// WEBPACK FOOTER //
// ./src/router/index.js